import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const surflyButton = {
	buttonTitle: 'Potřebuji poradit',
	// eslint-disable-next-line max-len
	tooltip:
		'Vzdálená pomoc. Ikona umožňuje sdílení obrazovky této webové aplikace. Potřebujete poradit? Zavolejte na Vaši podpůrnou linku. Jednoduchým kliknutím se připojíme k Vaší webové aplikaci a poradíme Vám.',
};

export default Object.assign({}, surflyButton, createLabeledMessages(surflyButton));
